var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180-269.231q-8.5 0-14.25-5.757-5.75-5.758-5.75-14.27 0-8.511 5.75-14.242 5.75-5.731 14.25-5.731h360q8.5 0 14.25 5.758t5.75 14.269q0 8.512-5.75 14.243-5.75 5.73-14.25 5.73H180ZM180-460q-8.5 0-14.25-5.758-5.75-5.757-5.75-14.269t5.75-14.242Q171.5-500 180-500h600q8.5 0 14.25 5.758 5.75 5.757 5.75 14.269t-5.75 14.242Q788.5-460 780-460H180Zm0-190.769q-8.5 0-14.25-5.758T160-670.796q0-8.512 5.75-14.243 5.75-5.73 14.25-5.73h600q8.5 0 14.25 5.757 5.75 5.758 5.75 14.27 0 8.511-5.75 14.242-5.75 5.731-14.25 5.731H180Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.ebde30aa8c133196261c1e60d998f073.svg";
export { ForwardRef as ReactComponent };